import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  buildReferralLink,
  clearReferralAttribution as clearStoredReferral,
  getStoredReferralAttribution,
  persistReferralAttribution,
  sanitizeReferralCode
} from "../../utils/referralAttribution";

const defaultOptions = { trackQueryParam: true };

export default function useReferralAttribution(options = defaultOptions) {
  const { trackQueryParam = true } = options;
  const location = useLocation();
  const [referral, setReferral] = useState(() => getStoredReferralAttribution());

  useEffect(() => {
    if (!trackQueryParam) {
      return;
    }
    const params = new URLSearchParams(location.search);
    const rawCode = params.get("ref");
    if (!rawCode) {
      return;
    }
    const normalizedCode = sanitizeReferralCode(rawCode);
    if (!normalizedCode) {
      return;
    }
    const referralLink = buildReferralLink(normalizedCode);
    persistReferralAttribution({
      code: normalizedCode,
      link: referralLink,
      source: `${location.pathname}${location.search}`
    });
    setReferral({ code: normalizedCode, link: referralLink });
  }, [location.pathname, location.search, trackQueryParam]);

  const refreshReferral = () => {
    setReferral(getStoredReferralAttribution());
  };

  const clearReferral = () => {
    clearStoredReferral();
    setReferral(null);
  };

  return {
    referral,
    refreshReferral,
    clearReferral
  };
}
